import React, { FC, Fragment } from 'react';
import { useMatch } from 'react-router-dom';
import { Grid, CardContent, Divider, Box } from '@material-ui/core';

import { Separator, UserAvatarGroup } from 'components';
import { useContent } from 'hooks';
import * as paths from 'paths';

import {
  Date,
  Groups,
  Reactions,
  Pin,
  Pinned,
  Reposts,
  Share,
  Engage,
  Commentary,
} from '../widgets';
import { getApprovedGroups, isEngageable } from '../helpers';
import { useCanShare } from '../hooks';
import { ShareCountModal } from '../widgets';

const Meta: FC = () => {
  const content = useContent();
  const isContent = useMatch(paths.content);
  const showEngage = isEngageable(content);
  const showShare = useCanShare(content) && !isContent;
  const approvedGroups = getApprovedGroups(content);

  const { content_id, publish_at, shared_by, share_count } = content;

  return (
    <Fragment>
      <CardContent>
        <Grid container alignItems="center">
          <Grid item container>
            <Pin />
            <Groups groups={approvedGroups} />
            {!!approvedGroups.length && <Separator />}
            <Date contentId={content_id} publishAt={publish_at} />
          </Grid>

          <Grid item container alignItems="center">
            {!isContent && !!shared_by?.length && (
              <Grid item xs={12}>
                <Box marginBottom={0} marginTop={3}>
                  <UserAvatarGroup users={content.shared_by} size={32} />
                </Box>
              </Grid>
            )}

            <Grid item xs={4}>
              <Box paddingY={1}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item>
                    <Reactions />
                  </Grid>
                  {!!share_count && (
                    <Grid item>
                      <ShareCountModal />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>

            {(showShare || showEngage) && (
              <Grid item xs={8} container justify="flex-end" spacing={1}>
                {showShare && (
                  <Grid item>
                    <Share />
                  </Grid>
                )}
                {showEngage && (
                  <Grid item>
                    <Engage />
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </CardContent>

      <Divider />

      <Reposts />
      <Pinned />
      {!isContent && <Commentary />}
    </Fragment>
  );
};

export default Meta;
